import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

import { Footer, Header } from '@ciam/ui';

import type { HTMLAttributes } from 'react';

export interface AuthLayoutProps extends HTMLAttributes<HTMLElement> {
  marginTop: string;
}

export const AuthLayout = ({ marginTop, ...props }: AuthLayoutProps) => {
  return (
    <>
      <Header />
      <Main $marginTop={marginTop} {...props}>
        <Outlet />
      </Main>
      <Footer page="login" />
    </>
  );
};

const Main = styled.main<{ $marginTop: AuthLayoutProps['marginTop'] }>`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ $marginTop }) => $marginTop};
`;
